import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
interface Props {
  href: string | null;
  isNewTab?: boolean;
  children: React.ReactNode;
}
export default function GalleryCardWrapper(t0) {
  const $ = _c(7);
  const {
    href,
    isNewTab,
    children
  } = t0;
  if (href) {
    const t1 = isNewTab ? "_blank" : undefined;
    const t2 = isNewTab ? "noopener noreferrer" : undefined;
    let t3;
    if ($[0] !== children || $[1] !== href || $[2] !== t1 || $[3] !== t2) {
      t3 = <Link href={href} className="block h-full w-full no-underline!" target={t1} rel={t2}>{children}</Link>;
      $[0] = children;
      $[1] = href;
      $[2] = t1;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t1;
  if ($[5] !== children) {
    t1 = <div className="h-full w-full">{children}</div>;
    $[5] = children;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}